<div class="payment-overlay" [class.payment-overlay--visible]="isVisible">
  <div class="payment-overlay__backdrop" (click)="handleCloseOverlayClick()"></div>

  <div class="payment-overlay__content">
    <!-- Header -->
    <div class="payment-overlay__header">
      <div class="payment-overlay__logo">
        <i class="fas fa-ticket-alt"></i>
        <span>Yes7Tickets</span>
      </div>
      @if (errorMessage) {
        <button class="payment-overlay__close" (click)="handleCloseOverlayClick()">
          <i class="fas fa-times"></i>
        </button>
      }
    </div>

    <!-- Main Content -->
    <div class="payment-overlay__main">
      <!-- Payment Method Info -->
      <div class="payment-method-info">
        <div class="payment-method-info__icon">
          <i [class]="getPaymentMethodIcon()"></i>
        </div>
        <div class="payment-method-info__text">
          <h3>Processando pagamento</h3>
          <p>Método: {{ getPaymentMethodText() }}</p>
        </div>
      </div>

      <!-- Progress Steps -->
      <div class="payment-steps">
        @for (step of steps; track step; let i = $index) {
          <div [class]="getStepClass(step)">
            <div class="payment-step__icon">
              <i [class]="getStepIcon(step)"></i>
            </div>
            <div class="payment-step__content">
              <h4 class="payment-step__title">{{ step.title }}</h4>
              <p class="payment-step__description">{{ step.description }}</p>
            </div>
            @if (i < steps.length - 1) {
              <div class="payment-step__connector"></div>
            }
          </div>
        }
      </div>

      <!-- Error Message -->
      @if (errorMessage) {
        <div class="payment-error">
          <div class="payment-error__icon">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="payment-error__content">
            <h4>Erro no pagamento</h4>
            <p>{{ errorMessage }}</p>
          </div>
        </div>
      }

      <!-- Loading Animation -->
      @if (!errorMessage) {
        <div class="payment-loading">
          <div class="payment-loading__spinner">
            <div class="spinner"></div>
          </div>
          <p class="payment-loading__text">Aguarde enquanto processamos seu pagamento...</p>
        </div>
      }
    </div>

    <!-- Footer -->
    <div class="payment-overlay__footer">
      <p class="payment-overlay__disclaimer">
        <i class="fas fa-shield-alt"></i>
        Seus dados estão protegidos com criptografia SSL
      </p>
    </div>
  </div>
</div>
